export const SPOTLIGHT_STORAGE_KEY = 'spotlight-price-history'
